import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { toast } from "sonner";
import * as serviceworker from "./serviceWorker";
import App from "./App";

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

serviceworker.register({
	onUpdate: () => {
		toast("Nova atualização disponível! Clique para atualizar.", {
			duration: Infinity,
			action: {
				label: "Atualizar",
				onClick: () => {
					if (window.location) {
						window.location.reload(true);
					}
				},
			},
		});
	},
});